var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "c-card",
          {
            staticClass: "cardClassDetailForm",
            attrs: { title: "평가 점수 환산표 정보", bgClass: "grey-3" },
          },
          [
            _c(
              "template",
              { slot: "card-button" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [_c("c-btn", { attrs: { label: "개정", icon: "save" } })],
                  1
                ),
              ],
              1
            ),
            _c("template", { slot: "card-detail" }, [
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("c-text", {
                    attrs: { label: "제/개정 번호", value: _vm.info.col1 },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("c-text", {
                    attrs: { label: "제/개정 일자", value: _vm.info.col2 },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("c-text", {
                    attrs: { label: "제/개정 사유", value: _vm.info.col3 },
                  }),
                ],
                1
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "c-table",
          {
            ref: "table",
            attrs: {
              title: "평가 점수 환산표 목록",
              tableId: "accidentSeq",
              columns: _vm.grid.columns,
              data: _vm.grid.data,
              usePaging: false,
              columnSetting: false,
            },
            on: { linkClick: _vm.linkClick },
          },
          [
            _c("template", { slot: "table-button" }, [
              _c(
                "div",
                [
                  _c(
                    "q-btn-group",
                    [
                      _c("c-btn", {
                        attrs: { label: "항목 추가", icon: "add" },
                        on: { btnClicked: _vm.addrow },
                      }),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "저장", icon: "save" },
                          })
                        : _vm._e(),
                      _c("c-btn", { attrs: { label: "삭제", icon: "remove" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }